import * as React from 'react';

import { Title, Text, Button } from '@/shared/ui/elements';
import { InfoNotice } from '@/shared/ui/components';
import IconGear from '@/shared/assets/icons/icon-gear.svg';

export const Intro = ({ setSelecting }) => {
  return (
    <div>
      <Title>
        We would like to know more about you!
      </Title>
      <Text>
        Help us understand your shift preferences, so that we can personalize
        the VetPoint experience for you.
      </Text>
      <Button primary onClick={setSelecting}>
        Let&apos;s Go!
      </Button>
      <InfoNotice
        icon={<IconGear />}
        style={{ marginTop: 20 }}
        message={(
          <>
            <b>Note —</b> these preferences can be set and changed within your profile settings,
            so if you&apos;re not sure, you can fill this out later.
          </>
        )}
      />
    </div>
  );
};
